import FeaturedAdController from 'partial/FeaturedAd/FeaturedAdController';

export default FeaturedAdController;
